import { createContext, useContext, type MouseEvent, type ReactNode } from 'react'

/** No-op by default so server rendering still produces plain crawlable anchors. */
export const NavigateContext = createContext<(to: string) => void>(() => {})

type LinkProps = {
  to: string
  children: ReactNode
  className?: string
  ariaLabel?: string
}

function isModifiedEvent(event: MouseEvent<HTMLAnchorElement>) {
  return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0
}

const Link = ({ to, children, className, ariaLabel }: LinkProps) => {
  const navigate = useContext(NavigateContext)

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (isModifiedEvent(event)) return
    event.preventDefault()
    navigate(to)
  }

  return (
    <a href={to} className={className} aria-label={ariaLabel} onClick={handleClick}>
      {children}
    </a>
  )
}

export default Link
